
import { defineComponent, inject, onMounted, ref } from 'vue';
import { Swiper } from 'swiper/vue';
import SwiperCore, { Controller, Navigation, Pagination } from 'swiper';
import InlineSvg from 'vue-inline-svg';

SwiperCore.use([Controller, Navigation, Pagination]);

export default defineComponent({
    setup() {
        let mainSwiper = ref<SwiperCore | null>(null);
        let thumbsSwiper = ref<SwiperCore | null>(null);

        const lazyLoad: any = inject('lazyLoad');
        onMounted(() => {
            lazyLoad.update();
        });
        const setMainSwiper = (swiper: SwiperCore) => {
            mainSwiper.value = swiper;
        }
        const setThumbsSwiper = (swiper: SwiperCore) => {
            thumbsSwiper.value = swiper;
        }

        return {
            mainSwiper,
            thumbsSwiper,
            setMainSwiper,
            setThumbsSwiper
        };
    },
    components: {
        swiper: Swiper,
        InlineSvg
    }
})
